import React, { useContext } from "react"
import { Link } from "react-router-dom"
import { toTitleCase } from "../../shared/helpers"
import AppContext from "../../shared/AppContext"

import "./topNav.scss"

const TopNav = (props) => {
  let { navItems, isActive, trackingLocation } = props

  const { trackEvent } = useContext(AppContext)

  return (
    <div className="top-nav-container">
      <div className="top-nav-links" data-cy="top-nav-links">
        {navItems.map((link, i) => (
          <div
            key={i}
            className={`top-nav-link-item ${isActive(link) && "active"}`}
          >
            <Link
              to={link.to}
              onClick={() => {
                trackEvent("Nav Link", {
                  location: trackingLocation,
                  text: link.title,
                  to: link.to,
                })
              }}
            >
              {toTitleCase(link.title)}
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TopNav
